



































import { Prop, Component, Vue } from "vue-property-decorator";
import ProjectMemberCard from "./ProjectMemberCard.vue";
import ProjectMemberCardViewModel from "@/viewmodels/project-member-card";

@Component({
  props: {
    appendable: Boolean,
    removable: Boolean
  },
  components: {
    ProjectMemberCard
  }
})
export default class ProjectMemberCardList extends Vue {
  @Prop({ default: "" }) title!: string;
  @Prop({ default: () => [] }) items!: ProjectMemberCardViewModel[];

  created() {
    // Fillter Staff is_hidden_info
    this.items = this.items.filter(item => item.isHiddenInfo === 0);
  }

  append() {
    this.$emit("append");
  }

  remove(id: number) {
    this.$emit("remove", id);
  }
}
